import React from 'react';
import { Route, Navigate } from 'react-router-dom';

function PrivateRoute({ children, ...rest }) {
    return localStorage.getItem("token") ? <>{children}</> : <Navigate to="/sign-in" />;
}
export default PrivateRoute;


